import styled from 'styled-components'

import { theme } from 'styles/theme'

import { fluidType } from '../fluid-type'

const { colors, fontWeights, lineHeights, media, space } = theme

export { Section } from 'components/general-styles/General'

export const Content = styled.div`
  position: relative;
`

/* No desenho (nó 4139:9666) o cadeado fica colado na borda esquerda do
   container, ocupa 27.8% da largura e começa no topo, junto do texto. Antes
   ficava centrado dentro de uma Col de 4 colunas — o que o deslocava para
   ~6% e o centrava na vertical, daí a aplicação diferente do protótipo.

   As coordenadas de vetor que a metadata do Figma devolve para esta seção não
   batem com o render (dizem 648, o desenho mostra 278), então as medidas aqui
   vieram da imagem do próprio desenho.

   A largura vai em fração do container, não na altura do texto: nossa coluna
   é mais estreita que a do desenho e quebra em mais linhas, então amarrar a
   altura faria o cadeado crescer junto.

   Decoração de traço: só entra quando há largura para ela sem apertar o
   texto, que é o conteúdo que importa aqui. */
export const Illustration = styled.div`
  display: none;

  @media (${media.desktop}) {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 27.8%;

    img {
      width: 100%;
      height: auto;
    }
  }
`

export const Infos = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xl']};

  p {
    margin: 0;
  }

  /* 744 dos 1343 do desenho, começando em 599 (44.6%). */
  @media (${media.desktop}) {
    width: 55.4%;
    margin-left: 44.6%;
  }
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['spacing-xl']};

  h2 {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    line-height: ${lineHeights['font-line-height-sm']};
    letter-spacing: -0.02em;
  }
`

export const PolygonWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
`

export const Highlight = styled.a`
  color: ${colors['pink-text-contrast']};
  font-weight: ${fontWeights['font-weight-bold']};
  text-decoration: underline;

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }
`

export const DpoLogo = styled.div`
  img {
    width: 10rem;
    height: auto;
  }
`
